import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  EDIT,
  SPACES,
  SUITES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
}

const LinkToSpaceAssetsInternalStorageSuites = ({
  children,
  spaceId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}/${EDIT}/${SUITES}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToSpaceAssetsInternalStorageSuites
